import {
  FlightDirect,
  FlightDirectAdditional,
  FlightDirectAdditionalMobile,
  FlightDirectMobile,
  FlightTransition,
  FlightTransitionAdditional,
  FlightTransitionAdditionalMobile,
  FlightTransitionMobile,
} from '@lt/components/icons-react/userflow/flights';

const FLIGHT_TRANSITION_ICONS = {
  mobile: {
    direct: {
      additional: FlightDirectAdditionalMobile,
      default: FlightDirectMobile,
    },
    transition: {
      additional: FlightTransitionAdditionalMobile,
      default: FlightTransitionMobile,
    },
  },
  desktop: {
    direct: {
      additional: FlightDirectAdditional,
      default: FlightDirect,
    },
    transition: {
      additional: FlightTransitionAdditional,
      default: FlightTransition,
    },
  },
};

export const getIcon = (
  isMobile: boolean,
  isAdditional: boolean,
  direct: boolean,
) =>
  FLIGHT_TRANSITION_ICONS[isMobile ? 'mobile' : 'desktop'][
    direct ? 'direct' : 'transition'
  ][isAdditional ? 'additional' : 'default'];
